import React from 'react';
import {
  HeroSection,
  MarketingLayerBand,
  MarketingMadeBand,
  MarketingPossibilitiesBand,
  ServiceCategories,
  FeaturedVendors,
  VendorSpotlight,
  VendorServices,
  MarketingStepsBand,
  MarketingExtraordinaryBand,
  MarketingAudienceBand,
  MarketingStoriesBand,
  MarketingDestinationsBand,
  MarketingHostCtaBand,
  MarketingClosingCta,
} from '../../components/home';
import CategoryServicesSkeleton from '../../components/shared/CategoryServicesSkeleton';
import { useHomeCategories } from '../../hooks/useHomeCategories';
import { useCategoryServices } from '../../hooks/useCategoryServices';
import useUserLocation from '../../hooks/useUserLocation';

const CategoryVendorServices = ({
  category,
  className = '',
  priceLabel = 'starting from',
  linkPrefix,
  userLocation,
}) => {
  const { services, isLoading, error } = useCategoryServices(category.id, {
    location: userLocation,
  });

  return (
    <VendorServices
      title={category.category_name || 'Services'}
      data={services}
      isLoading={isLoading}
      error={error}
      categorySlug={category.id}
      linkPrefix={linkPrefix || '/services'}
      priceLabel={priceLabel}
      className={className}
      emptyMessage={`No ${category.category_name?.toLowerCase()} services available`}
      emptyDescription="Check back later for new services"
    />
  );
};

/**
 * Home: Peerspace marketplace flow × Shopify marketing texture.
 * Editorial bands use dummy content; inventory rails stay live.
 */
const ClientHome = () => {
  const { categories, isLoading: categoriesLoading } = useHomeCategories();
  const { userLocation } = useUserLocation();

  return (
    <>
      <HeroSection />
      <MarketingLayerBand />
      <MarketingMadeBand />
      <MarketingPossibilitiesBand />

      <div className="overflow-hidden bg-m-canvas-light">
        <ServiceCategories />
        <FeaturedVendors />
      </div>

      <MarketingStepsBand />
      <MarketingExtraordinaryBand />

      <div className="overflow-hidden bg-m-canvas-light">
        {categoriesLoading ? (
          <CategoryServicesSkeleton sections={3} />
        ) : categories.length > 0 ? (
          categories.map((category, index) => {
            const shouldShowSpotlight = index === 3 && categories.length > 3;

            return (
              <React.Fragment key={category.id}>
                <CategoryVendorServices
                  category={category}
                  className={index % 2 === 1 ? 'bg-m-canvas-light' : 'bg-m-surface'}
                  priceLabel="starting from"
                  linkPrefix="/services"
                  userLocation={userLocation}
                />
                {shouldShowSpotlight ? <VendorSpotlight /> : null}
              </React.Fragment>
            );
          })
        ) : (
          <VendorSpotlight />
        )}

        {categories.length > 0 && categories.length <= 3 ? <VendorSpotlight /> : null}
      </div>

      <MarketingAudienceBand />
      <MarketingStoriesBand />
      <MarketingDestinationsBand />
      <MarketingHostCtaBand />
      <MarketingClosingCta />
    </>
  );
};

export default ClientHome;
